"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGenerateSlideBlocks = void 0;
var react_1 = require("react");
var useGenerateSlideBlocks = function (_a) {
    var cards = _a.cards, cardsInSlide = _a.cardsInSlide, _b = _a.countSlides, countSlides = _b === void 0 ? Math.floor(((cards === null || cards === void 0 ? void 0 : cards.length) || 1) / cardsInSlide) : _b;
    return (0, react_1.useMemo)(function () {
        var blocks = [];
        for (var i = 0; i < countSlides; i++) {
            var from = i * cardsInSlide;
            var to = from + cardsInSlide;
            if (cards && cards.length > from) {
                blocks.push(cards.slice(from, to));
            }
            else {
                break;
            }
        }
        return blocks;
    }, [cards, cardsInSlide, countSlides]);
};
exports.useGenerateSlideBlocks = useGenerateSlideBlocks;
